<template>
  <div class="common-layout">
    <el-container>
      <el-header class="header">
        <h3>web-sdk 监控平台</h3>
        <div class="actions">
          <el-button @click="refresh">刷新</el-button>
          <el-button type="primary" plain @click="go('home')"
            >返回测试台</el-button
          >
        </div>
      </el-header>
      <el-main>
        <Count ref="countRef" />
        <List ref="listRef" />
      </el-main>
    </el-container>
  </div>
</template>

<script setup lang="ts">
import { inject, onBeforeUnmount, onMounted, ref } from "vue";
import Count from "./Count.vue";
import List from "./List.vue";

const go = inject<(page: "home" | "dashboard") => void>("go", () => {});

const countRef = ref<InstanceType<typeof Count>>();
const listRef = ref<InstanceType<typeof List>>();
let timer: number | undefined;

function refresh() {
  countRef.value?.load();
  listRef.value?.load();
}

// 组件挂载时加载数据，并启动定时刷新
onMounted(() => {
  refresh();
  timer = window.setInterval(refresh, 8000);
});

onBeforeUnmount(() => {
  window.clearInterval(timer);
});

defineExpose({ refresh });
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dcdfe6;
  background-color: #fff;
}

.header h3 {
  margin: 0;
}
</style>
